// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"41296e7d","400":"97bfdd4e","501":"d5324cd6","617":"573cb685","711":"36683673","775":"46d549c3"}[chunkId] + ".chunk.css";
};